import { merge } from 'lodash'

import acronyms from './acronyms.sv.json'
import formDefaults from './formDefaults.sv.json'
import sv from './sv.json'

export default merge(sv, formDefaults, acronyms)
